import React, { useEffect, useState } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import CircularProgressBar from '../../common/CircularProgressBar';

interface Iprop {
  progressLabel: string;
}
const Progress = ({ progressLabel }: Iprop) => {
 

  return (
    <div className="progressbar-container">
      <div className="progressbar-wrapper">
        <Box sx={{ display: 'flex' }}>
          <CircularProgress />
        </Box>
        <p className="progress-label">{progressLabel}</p>
      </div>
    </div>
  );
};

export default Progress;
